module.exports = __webpack_public_path__ + "static/media/Icon_menu_location_white.94df0c9a.svg";